import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["className", "disabled", "label", "name", "validationMessage", "explanationMessage", "required", "wrapperProps"];
import * as React from 'react';
import clsx from 'clsx';
import { useTheme } from '@emotion/react';
import TextareaAutoSize from 'react-textarea-autosize';
import { form } from '../assets/styles/utility';
import { generateUUID } from '../helpers/utility';
import FormFooter from './FormFooter';
import ControlWrapper from './ControlWrapper';
import FormGroup from './FormGroup';
import ControlLabel from './ControlLabel';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const StylesTextareaBase = theme => [form.base(theme), form.input(theme), {
  // Remove default style in browsers that support `appearance`
  appearance: 'none',
  // Remove default vertical scrollbar in IE 8/9/10/11.
  overflow: 'auto',
  // Improve readability and alignment in all browsers.
  verticalAlign: 'text-top',
  // Only allow vertical resizing
  resize: 'vertical',
  // Force minimum height
  minHeight: theme.height.base * 2,
  // Allow `textarea` to be controlled via [row] more explicitly
  height: 'auto',
  // Style
  maxHeight: 300,
  // Slightly larger top padding than input
  paddingTop: form.variables(theme).controlOffset + theme.space.xsmall
}];
const Textarea = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    disabled,
    label,
    name,
    validationMessage,
    explanationMessage,
    required,
    wrapperProps
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const theme = useTheme(); // Only regenerate this if the name prop changes

  const id = React.useMemo(() => `${name}-${generateUUID()}`, [name]);
  return ___EmotionJSX(FormGroup, null, ___EmotionJSX(ControlWrapper, _extends({
    required: required,
    error: Boolean(validationMessage),
    disabled: disabled,
    iconAlignment: "top"
  }, wrapperProps), label && ___EmotionJSX(ControlLabel, null, label), ___EmotionJSX(TextareaAutoSize, _extends({
    css: StylesTextareaBase(theme, {
      required
    }),
    className: clsx('CK__Textarea', className),
    id: id,
    name: name,
    ref: ref
  }, rest))), ___EmotionJSX(FormFooter, {
    explanationMessage: explanationMessage,
    validationMessage: validationMessage
  }));
});
export default Textarea;